import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './routes'
import './i18n/config' // Initialize i18n
import './styles/global.css'
import './styles/blog.css'
import './styles/codeblock.css'

/**
 * Static generation, not a client-only mount.
 *
 * Every route in ./routes is rendered at build time into its own HTML file.
 * Before this, `vite build` produced a single index.html and GitHub Pages
 * answered every other path with 404.html plus a client-side URL rewrite —
 * so a crawler saw HTTP 404, no title and 99 words on 15 of 16 routes.
 *
 * ViteReactSSG provides the router itself, so there is no BrowserRouter here.
 * HelmetProvider is gone too: Seo.tsx now uses vite-react-ssg's <Head>, which
 * is what gets the per-route title and meta into the static HTML.
 */
export const createRoot = ViteReactSSG({ routes })
